import styled from "styled-components";

import { Button, PrimaryButton } from "components/Button";

export const MenuContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: 0 6px 0 40px;
  }
`;

export const LoginButton = styled.a`
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  width: 100%;
  padding: 10.5px 24px;
  color: ${({ theme }) => theme.customTheme.palette.black.black25};
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.customTheme.palette.black.black25};
  height: fit-content;
  border-radius: 28px;
  font-weight: 700;
  text-decoration: none;
  text-align: center;
`;

export const LogoutButton = styled(PrimaryButton)`
  padding: ${({ theme }) => theme.customTheme.pxToRem(10)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    width: 160px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CancelLogoutButton = styled(Button)`
  background: none;
  border: none;
  text-decoration: underline;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(22)};
  margin-top: 12px;
`;

export const LogButton = styled(PrimaryButton)`
  line-height: 20px;
  width: 100%;
  padding: 10.5px 24px;
  color: ${({ theme }) => theme.customTheme.palette.black.black25};
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.customTheme.palette.black.black25};
`;
